"use client";

import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhatOurClientsSay() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const testimonials = [{
    quote: "Elite Brushstrokes turned our dated living room into a modern masterpiece. Their precision and attention to detail are truly unmatched in the industry.",
    initials: "A. K.",
    location: "RESIDENTIAL / DOWNTOWN",
    architect: "in collaboration with Urban Living Design"
  }, {
    quote: "The exterior transformation was flawless. They treated our home with such care, and the final finish is absolutely stunning. Highly recommended.",
    initials: "B. M.",
    location: "ESTATE / NORTH HILLS",
    architect: "in collaboration with Heritage Home Group"
  }, {
    quote: "Professional, clean, and incredibly talented. They understood our vision perfectly and executed it with a level of craftsmanship we haven't seen before.",
    initials: "L. T.",
    location: "VILLA / RIVER SIDE",
    architect: "in collaboration with Studio Moderno"
  }, {
    quote: "From the initial consultation to the final walkthrough, the process was seamless. Our home feels brand new thanks to their expert touch.",
    initials: "J. S.",
    location: "TOWNHOUSE / WEST END",
    architect: "in collaboration with Prime Architecture"
  }];
  useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  const formatIndex = (n: number) => String(n + 1).padStart(2, "0");
  return <section data-section-id="5215" id="what-our-clients-say" ref={ref} className="relative bg-background text-foreground overflow-hidden py-32 md:py-44 lg:py-[180px] px-4 sm:px-6" style={{
    backgroundImage: "radial-gradient(ellipse 60% 50% at 50% 0%, hsla(22, 90%, 55%, 0.05), transparent 70%)"
  }}>
      <div className={`max-w-[980px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="text-center mb-6">
          <span className="font-mono text-xs tracking-[0.3em] text-primary uppercase">
            03 / Client Testimonials
          </span>
        </div>

        {}
        <h2 className="text-center font-serif font-default text-3xl sm:text-4xl md:text-5xl text-foreground italic font-light mb-20 md:mb-28">
          Voices of Excellence.
        </h2>

        {}
        <div className="relative" onMouseEnter={() => {}}>
          <Carousel setApi={setApi} opts={{
          loop: true,
          align: "start"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((t, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-2 sm:px-6">
                    {}
                    <div aria-hidden="true" className="font-serif text-primary leading-none select-none" style={{
                  fontSize: "clamp(96px, 14vw, 160px)",
                  marginBottom: "-40px"
                }}>
                      &ldquo;
                    </div>

                    {}
                    <blockquote className="font-serif text-foreground text-xl sm:text-2xl md:text-[32px] leading-[1.5] font-light italic max-w-[860px]">
                      {t.quote}
                    </blockquote>

                    {}
                    <div className="mt-12 mb-8 h-px w-20 bg-primary/20" />

                    {}
                    <div className="flex flex-col items-center gap-2">
                      <span className="font-mono text-sm text-primary tracking-[0.25em] uppercase">
                        {t.initials}
                      </span>
                      <span className="font-mono text-xs text-foreground/60 tracking-[0.2em]">
                        {t.location}
                      </span>
                      <span className="font-serif italic text-sm text-foreground/60 mt-1">
                        {t.architect}
                      </span>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="mt-16 md:mt-20 flex items-center justify-between max-w-[680px] mx-auto">
            <Button variant="ghost" size="icon" onClick={() => api?.scrollPrev()} aria-label="Previous testimonial" className="text-primary hover:text-primary hover:bg-transparent rounded-lg">
              <ArrowLeft className="size-5" strokeWidth={1.25} />
            </Button>

            <div className="font-mono text-xs sm:text-sm tracking-[0.3em] text-foreground/60">
              <span className="text-primary">{formatIndex(current)}</span>
              <span className="mx-2 text-primary/20">/</span>
              <span>{formatIndex(count - 1 < 0 ? 0 : count - 1)}</span>
            </div>

            <Button variant="ghost" size="icon" onClick={() => api?.scrollNext()} aria-label="Next testimonial" className="text-primary hover:text-primary hover:bg-transparent rounded-lg">
              <ArrowRight className="size-5" strokeWidth={1.25} />
            </Button>
          </div>
        </div>
      </div>
    </section>;
}